<template>
  <div class="user-management">
    <template>
       <h4 style="color: aliceblue;margin-top: -30px">
         用户管理
       </h4>
     </template>
    <el-row :gutter="40">
      <!--部门数据-->
      <!-- <el-col :span="4" :xs="24">
        <div class="head-container">
          <el-input
            v-model="deptName"
            clearable
            placeholder="请输入部门名称"
            prefix-icon="el-icon-search"
            size="small"
            style="margin-bottom: 20px"
          />
        </div>
        <div class="head-container">
          <el-tree
            ref="tree"
            :data="deptOptions"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            default-expand-all
            @node-click="handleNodeClick"
          />
        </div>
      </el-col> -->

      <el-col :span="24" :xs="24">
        <el-form
          ref="queryForm"
          :inline="true"
          :model="queryParams"
          label-width="68px"
          size="small"
        >
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
            v-if="roleType==1"
              >新增
            </el-button>
            <el-button
              :disabled="single"
              icon="el-icon-edit"
              type="success"
              style="margin-left:15px"
              @click="handleUpdate"
              >修改
            </el-button>
            <el-button
              :disabled="multiple"
              icon="el-icon-delete"
              type="danger"
              style="margin-left:15px"
              @click="handleDelete"
              >删除
            </el-button>
            <el-button icon="el-icon-plus" type="primary" @click="handleAddChild"
              >新增子账号
            </el-button>
          </el-form-item>

          <el-form-item  prop="coId">
            <el-select v-model="queryParams.coId" filterable clearable placeholder="所属企业">
              <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
            </el-select>
          </el-form-item>

          <el-form-item prop="username">
            <el-input
              v-model="queryParams.username"
              clearable
              placeholder="用户名、用户昵称、手机号"
              size="small"

              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <!-- <el-form-item prop="nickname">
            <el-input
              v-model="queryParams.nickname"
              clearable
              placeholder="用户昵称"
              size="small"

              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item prop="mobile" style="margin-left: 10px">
            <el-input
              v-model="queryParams.mobile"
              clearable
              placeholder="手机号码"
              size="small"

              @keyup.enter.native="handleQuery"
            />
          </el-form-item> -->

          <el-form-item prop="roleId" style="margin-left: 10px">
            <el-select
                v-model="queryParams.roleId"
                clearable
                placeholder="用户类型"
                style="width: 150px"
                :disabled="accountType == 1 || roleType != 1"
              >
                <el-option
                  v-for="(item, index) in roleOptions"
                  :label="item.name"
                  :value="item.id.toString()"
                  :key="index"
                />
              </el-select>
          </el-form-item>

          <el-form-item prop="status" style="margin-left: 10px">
            <el-select
              v-model="queryParams.status"
              clearable
              size="small"
              style="width: 150px"
              placeholder="状态"
            >
              <el-option label="正常" value="1" />
              <el-option label="停用" value="0" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="handleQuery"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="handleReset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          v-loading="loading"
          element-loading-text="数据载入中"
          element-loading-spinner="el-icon-loading"
          :data="pageList"
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" type="selection" width="50" />
          <el-table-column
            align="center"
            label="用户编号"
            prop="id"
            width="150"
          />
          <el-table-column
            align="center"
            label="所属企业"
            prop="coName"
          />
          <el-table-column
            align="center"
            label="用户名"
            prop="username"
          />
          <el-table-column
            align="center"
            label="用户昵称"
            prop="nickname"
            width="200"
          />
          <el-table-column
            align="center"
            label="性别"
            prop="gender"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.gender === 1">男</span>
              <span v-if="scope.row.gender === 2">女</span>
              <span v-if="scope.row.gender === 0">未知</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            align="center"
            label="部门"
            prop="deptName"
            width="150"
          /> -->
          <el-table-column align="center" label="用户类型" prop="roleNames" width="150"/>
          <el-table-column
            align="center"
            label="手机号码"
            prop="mobile"
            width="200"
          />
          <el-table-column align="center" label="状态" width="150">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="handleStatusChange(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                circle
                plain
                @click.stop="handleUpdate(scope.row)"
              />
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                circle
                plain
                @click.stop="handleDelete(scope.row)"
              />
              <el-button
                type="info"
                icon="el-icon-key"
                size="mini"
                circle
                plain
                @click.stop="handleResetPassword(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>

        <commonPagination
          :page="pagination"
          :pageSizes="[10, 20, 30, 40, 50, 100]"
          :getList="handleQuery"
        ></commonPagination>
      </el-col>
    </el-row>
    <!-- 新增或修改参数配置对话框 -->
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      width="800px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="主账号" prop="parentId" v-if="accountType == 1" >
              <el-select v-model="form.parentId" filterable placeholder="请输入或选择" style="width: 280px" @change="selectChange($event)" :disabled="true">
                <!-- <el-option v-for="(item, index) in parentId" :key="index" :label="item.lable" :value="String(item.value)" /> -->
                <el-option   :label="form.parentName || username" :value="String(form.parentId) || String(user_id)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名" prop="username">
              <el-input
                v-model="form.username"
                :disabled="form.id !== undefined"
                placeholder="请输入用户名"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="dialog.flag === 0"
              label="用户密码"
              prop="password"
            >
              <el-input
                v-model="form.password"
                type="text"
                placeholder="请输入用户密码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户昵称" prop="nickname">
              <el-input v-model="form.nickname" placeholder="请输入用户昵称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别">
              <el-select v-model="form.gender" placeholder="请选择">
                <el-option label="未知" :value="0" />
                <el-option label="男" :value="1" />
                <el-option label="女" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="角色" prop="roleIds">
              <el-select
                v-model="form.roleIds"
                placeholder="请选择角色"
                style="width: 250px"
                
              >
                <el-option
                  v-for="(item, index) in roleOptions"
                  :label="item.name"
                  :value="item.id.toString()"
                  :key="index"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="mobile">
              <el-input
                v-model="form.mobile"
                maxlength="11"
                placeholder="请输入手机号码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="form.email"
                maxlength="50"
                placeholder="请输入邮箱"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属企业" prop="coId">
              <el-select v-model="form.coId" filterable placeholder="请输入或选择" style="width: 280px" :disabled="accountType == 1">
                <el-option v-for="(item, index) in company" :key="index" :label="item.lable" :value="String(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="deptId">
              <tree-select
                v-model="form.deptId"
                :options="deptOptions"
                placeholder="请选择归属部门"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio-group v-model="form.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="form.remark"
                placeholder="请输入内容"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialog.visible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TreeSelect from "@riophae/vue-treeselect";
import commonPagination from "@/components/commonPagination.vue";
export default {
  name: "User-management",
  components: {
    commonPagination,
    TreeSelect
  },
  props: {},
  data() {
    return {
      company:[],
      parentId:[],
      roleType: JSON.parse(localStorage.getItem('userInfo')).roleType,
      username: JSON.parse(localStorage.getItem('userInfo')).username,
      user_id: JSON.parse(localStorage.getItem('userInfo')).user_id,
      accountType:0,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      queryParams: {
        username: undefined,
        mobile: undefined
      },
      queryParams2: {
        page: 1,
        limit: 100,
        accountType: 0
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      pageList: [],
      dialog: {
        title: undefined,
        visible: false,
        flag: 0
      },
      // 部门名称
      deptName: undefined,
      // 部门树选项
      deptOptions: undefined,
      // 角色选项
      roleOptions: [],
      roletype:"",
      // 表单参数
      form: {
        avatar: "",
        coId: "",
        coName: "",
        deleted: 0,
        deptId: 0,
        deptName: "",
        gender: 0,
        gmtCreate: "",
        gmtModified: "",
        id: undefined,
        idcard: "",
        mobile: "",
        nickname: "",
        otherInfo: "",
        password: "",
        roleIds: [],
        roleNames: "",
        status: 1,
        userType: "0",
        username: "",
        accountType: 0,
        parentId:""
      },
      queryParam: {
        pageIndex: 0,
        pageRow: 300,
      },
      apiUrl: {
        Enterpriseinfo: 'POST_hyEnterpriseByRole',
      },
      // 表单校验
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "用户密码不能为空", trigger: "blur" }
        ],
        roleId: [
          { required: true, message: "用户角色不能为空", trigger: "blur" }
        ],
        coId: [
          { required: true, message: "企业不能为空", trigger: "blur" }
        ],
        deptId: [
          { required: true, message: "归属部门不能为空", trigger: "blur" }
        ],
        roleIds: [
          { required: true, message: "角色不能为空", trigger: "blur" }
        ],
        parentId: [
          { required: true, message: "主账号不能为空", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        mobile: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    async loadData() {
      this.handleQuery();
      await this.loadDeptOptions();
    },
    handleQuery(obj = {}) {
      if ("pageNo" in obj) {
        this.queryParams.page = this.pagination.page = obj.pageNo;
      } else {
        this.queryParams.page = 1;
      }
      if ("pageSize" in obj) {
        this.queryParams.limit = this.pagination.limit = obj.pageSize;
      } else {
        this.queryParams.limit = this.pagination.limit;
      }
      this.$http.GET_usersList({ params: this.queryParams }).then(response => {
        const { data, total } = response;
        this.pageList = data;
        this.pagination.total = total;
        this.loading = false;
      });
    },
    handleReset() {
      this.pagination = {
        page: 1,
        limit: 10,
        total: 0
      };
      this.queryParams = {
        username: undefined,
        mobile: undefined
      };
      this.handleQuery();
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.label.indexOf(value) !== -1;
    },
    // 部门节点单击事件
    handleNodeClick(data) {
      this.queryParams.deptId = data.id;
      this.handleQuery();
    },
    // 用户状态修改
    handleStatusChange(row) {
      const text = row.status === 1 ? "启用" : "停用";
      this.$confirm('确认要"' + text + row.username + '"用户吗?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return this.$http.PATCH_adminUsersUpdate2({
            paramsID: row.id,
            password: row.password,
            status: row.status
          });
        })
        .then(() => {
          this.$message.success(text + "成功");
        })
        .catch(() => {
          row.status = row.status === 0 ? 1 : 0;
        });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    async handleAdd() {
      this.resetForm();
      this.accountType = 0;
      this.form.accountType = 0;
      this.dialog = {
        title: "新增用户",
        visible: true,
        flag: 0
      };
      await this.loadRoleOptions();
      await this.loadDeptOptions();
    },
    async handleAddChild() {
      this.resetForm();
      this.accountType = 1;
      this.form.accountType = 1;
      this.form.parentId = String(JSON.parse(localStorage.getItem('userInfo')).user_id);
      this.dialog = {
        title: "新增子用户",
        visible: true,
        flag: 0
      };
      await this.loadRoleOptions();
      await this.loadDeptOptions();
      this.$http.GET_usersDetail({ paramsID: this.form.parentId }).then(response => {
        this.form.coId = response.data.coId
        this.form.roleIds = response.data.roleIds[0]
      });
      //this.getParentId();
    },
    async handleUpdate(row) {
      this.resetForm();
      if(row.accountType == 1){
        this.accountType = 1;
      }else{
        this.accountType = 0;
      }
      this.dialog = {
        title: "修改用户",
        visible: true,
        flag: 1
      };
      await this.loadRoleOptions();
      await this.loadDeptOptions();
      const id = row.id || this.ids;
      this.$http.GET_usersDetail({ paramsID: id }).then(response => {
        this.form = response.data;
        this.form.roleIds = response.data.roleIds[0]
      });
    },
    handleSubmit: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const id = this.form.id;
          if (id !== undefined) {
            this.form.paramsID = this.form.id;
            if(!(this.form.roleIds instanceof Array)){
              this.form.roleIds = [this.form.roleIds];
            }
            this.$http.PUT_usersUpdate(this.form).then((res) => {
              if(res.code == '00000'){
                this.$message.success("修改成功");
                this.dialog.visible = false;
                this.handleQuery();
              }else{
                this.$message.error(res.msg);
              }
            });
          } else {
            if(!(this.form.roleIds instanceof Array)){
              this.form.roleIds = [this.form.roleIds];
            }
            //this.form.password = this.$aes.encrypt(this.form.password);//加密
            this.$http.POST_usersAdd(this.form).then((res) => {
              if(res.code == '00000'){
                this.$message.success("新增成功");
                this.dialog.visible = false;
                this.handleQuery();
              }else{
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },
    handleDelete(row) {
      const ids = row.id || this.ids.join(",");
      this.$confirm("是否确认删除选中的数据项?", '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.DELETE_usersDel({ paramsID: ids }).then(response => {
          this.$message.success("删除成功");
          this.handleQuery();
        });
      }).catch(() => this.$message.info("已取消删除"));
    },
    handleResetPassword(row) {
      const id = row.id || this.ids;
      this.$prompt('请输入"' + row.username + '"的新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: value => {
          if (!value || value.trim().length < 1) {
            return "请填写新密码";
          }
        }
      })
        .then(({ value }) => {
          //let newPassword = this.$aes.encrypt(value);//加密
          this.$http.PATCH_adminUsersUpdate2({
            paramsID: id,
            password: value,
            status: 1
          }).then((res) => {
            if(res.code == '00000'){
              this.$message.success("修改成功，新密码是：" + value);
            }else{
              this.$message.error(res.msg)
            }
          });
        })
        .catch(() => {});
    },
    loadRoleOptions() {
      this.$http.GET_roleList().then(response => {
        console.log("aaaaa", response);
        this.roleOptions = response.data;
      });
    },
    loadDeptOptions() {
      console.log("bbbbbb");
      this.$http.GET_deptTree().then(response => {
        console.log("aaaaaa", response);
        this.deptOptions = [
          {
            id: 0,
            label: "化工园区",
            children: response.data
          }
        ];
      });
    },
    getCompany(){
      this.$http[this.apiUrl.Enterpriseinfo](this.queryParam).then(res => {
        if(res.data.length>1){
          res.data.forEach((element, key) => {
            this.company.push({
              lable: element.coName,
              value: element.id,
            });
          });
        }else{
          this.company.push({
            lable: res.data.coName,
            value: res.data.id,
          });
        }
      });
    },
    getParentId(){
      this.parentId = [];
      this.$http.GET_sameRoletype({ paramsID: 2 }).then(res => {
          res.data.forEach((element, key) => {
            this.parentId.push({
              lable: element.username,
              value: element.id,
            });
          });
      });
    },
    selectChange(value){
      const id = value;
      this.$http.GET_usersDetail({ paramsID: id }).then(response => {
        this.form.coId = response.data.coId
        this.form.roleIds = response.data.roleIds[0]
      });
    },
    getRole(value){
      let obj={};
      this.form.coId = [];
      obj = this.roleOptions.find((item)=>{
          if(item.id == value){
            this.roletype = item.roleType;
            }
      });
    },
    // 表单重置
    resetForm() {
      this.form = {
        avatar: "",
        coId: "",
        coName: "",
        deleted: 0,
        deptId: 0,
        deptName: "",
        gender: 0,
        gmtCreate: "",
        gmtModified: "",
        id: undefined,
        idcard: "",
        mobile: "",
        nickname: "",
        otherInfo: "",
        password: "",
        roleIds: [],
        roleNames: "",
        status: 1,
        userType: "0",
        username: "",
        accountType: 0,
        parentId:""
      };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    }
  },
  created() {
    this.loadData();
    this.getCompany();
    this.loadRoleOptions();
  },
  watch: {
    // 根据名称筛选部门树
    deptName(val) {
      this.$refs.tree.filter(val);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/sysmenu/user-management.vue